import { createTheme, responsiveFontSizes } from '@mui/material/styles';

const palette = {
  primary: {
    main: "#00884C",
    light: "#8CC63F",
    dark: "#005F35"
  },
  secondary: {
    main: "#FFDB4D",
    light: "#F39200",
  },
  neutral: {
    main: "#717171",
    light: "#eee",
    dark: "#C1C1C1"
  }
};

export const theme = createTheme({
  palette: {
    primary: {
      main: palette.primary.main,
      light: palette.primary.light,
      dark: palette.primary.dark
    },
    secondary: {
      main: palette.secondary.main,
      light: palette.secondary.light,
    },
    neutral: {
      main: palette.neutral.main,
      light: palette.neutral.light,
      dark: palette.neutral.dark
    }
  },
  typography: {
    fontFamily: 'Proxima Nova Rg'
  },
  components: {
    MuiDivider: {
      styleOverrides: {
        root: {
          margin: '0.875rem 0'
        }
      }
    },
    MuiTypography: {
      variants: [
        {
          props: { variant: 'smallBold' },
          style: {
            fontWeight: 600,
            fontSize: '13px',
            fontFamily: 'Proxima Nova Rg'
          }
        },
        {
          props: { variant: 'bold' },
          style: {
            fontWeight: 600,
            fontFamily: 'Proxima Nova Rg'
          }
        },
        {
          props: { variant: 'small' },
          style: {
            fontSize: '13px',
            fontFamily: 'Proxima Nova Rg'
          },
        },
      ]
    },
    MuiLink: {
      styleOverrides: {
        root: {
          fontFamily: 'Proxima Nova Rg',
          '& .MuiTypography-root': {
            '&:hover': {
              color: `${palette.primary.main} !important`
            }
          }
        },

      }
    },
    MuiLinearProgress: {
      styleOverrides: {
        dashed: {
          backgroundImage: 'unset'
        },
        barColorPrimary: {
          backgroundColor: palette.primary.light
        },
        buffer: {
          backgroundColor: palette.neutral.light
        },
        bar2Buffer: {
          backgroundColor: palette.secondary.main
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderWidth: '1px'
        },
        outlined: {
          ":active": {
            border: `1px solid ${palette.primary.main}`,
          },
          ":focus": {
            border: `1px solid ${palette.primary.main}`,
          },
        },
      }
    },
    MuiChip: {
      styleOverrides: {
        outlined: {
          ":hover": {
            borderColor: palette.primary.main,
            color: palette.primary.main,
            backgroundColor: 'transparent !important'
          }
        },
        filled: {
          backgroundColor: palette.primary.main,
          borderColor: palette.primary.main,
          color: 'white',
          ":hover": {
            backgroundColor: palette.primary.dark,
            borderColor: palette.primary.dark,
            color: "white"
          }
        }
      }
    },
    MuiInput: {
      styleOverrides: {
        root: {
          "::placeholder": {
            color: "#D2C9C9 !important"
          }
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          ":disabled": {
            cursor: 'not-allowed'
          },
          ':-webkit-autofill': {
            WebkitBoxShadow: '0 0 0 100px white inset',
          },
        }
      }
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          '&:hover': {
            color: 'white',
            backgroundColor: `${palette.primary.main} !important`,
          }
        }
      }
    },
    MuiAutocomplete: {
      styleOverrides: {
        option: {
          '&:hover': {
            backgroundColor: `${palette.primary.main} !important`,
            color: 'white'
          }
        }
      }
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: palette.neutral.light,
        }
      }
    },
    MuiAvatar: {
      styleOverrides: {
        root: {
          height: '100%',
          width: '100%',
          fontSize: '1rem',
          backgroundColor: palette.primary.light
        }
      }
    },
  },
});
const responsiveTheme = responsiveFontSizes(theme)
export default responsiveTheme;